module.exports = __webpack_public_path__ + "img/john.f802cdd3.jpg";